import { Inject, Injectable } from "@angular/core";
import { Storage } from '@ionic/storage';
import saveAs from 'file-saver';
import { Platform } from 'ionic-angular';
import moment from 'moment';
import { Observable } from 'rxjs/Rx';
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { LoopBackAuth } from "../../shared/sdk";
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { RequestDownloadExcelDto, RequestDownloadPdfDto } from './../../shared/nestjs/gd-only/dto/claim-report.dto';
import { ClaimReportApi } from './../../shared/nestjs/gd-only/services/claim-report.api';
import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { SFClaimReportApi } from './../../shared/sdk/services/custom/SFClaimReport';
@Injectable()
export class ClaimReportBloc {

    SFGoAuth: any;
    allEmp: any = 1;
    listEmp: any = [];
    empName: any;
    startDate: any = moment().toISOString();
    endDate: any = moment().toISOString();
    reportType: any;
    claimType: any = [];
    companyId: any;
    companyCode: any;
    leaveName: any;
    isSF6: boolean = false;

    constructor(
        @Inject(LoopBackAuth) protected auth: LoopBackAuth,
        private claimReportApi: ClaimReportApi,
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private sFClaimReportApi: SFClaimReportApi,
        private storage: Storage,
        private analyticsProvider: AnalyticsProvider,
    ) {

    }

    ionViewDidLoad() {
        this.storage.get('SFGoAuth').then(result => {
            this.SFGoAuth = JSON.parse(result);
            console.log('SFGoAuth', this.SFGoAuth);
        })
    }

    generatePreview(obj_data): Observable<any> {
        return this.sFClaimReportApi.previewReport(JSON.stringify(obj_data))
    }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Claim Report')
        } else {
            saveAs(data, 'Claim Report.xlsx')
        }
    }

    downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.claimReportApi.downloadExcel(data);
    }

    downloadExcelLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            
        })
    }

    generatePdf(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadPdfBlob(data, 'Claim Report')
        } else {
            saveAs(data, 'Claim Report.pdf')
        }
    }

    downloadPdf(data: RequestDownloadPdfDto): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
        return this.claimReportApi.downloadPdf(data);
    }

    downloadPdfLB(data): Promise<any> {
        return new Promise(async (resolve, reject) => {
            
        })
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.claimReportApi.reportSendEmailExcel(data)
                } else {
                    let obj_data = {
                        'allEmp': data.allEmp,
                        'listEmp': data.listEmp,
                        'startDate': data.startDate,
                        'endDate': data.endDate,
                        'reportType': data.reportType,
                        'claimType': data.claimType,
                        'companyId': data.companyId,
                        'companyCode': data.companyCode,
                        'fullName': data.fullName,
                        'emailUser': data.SFGoAuth.email,
                        'sendEmail': true,
                        'isSF6': data.isSF6
                    };
                    return this.sFClaimReportApi.download(JSON.stringify(obj_data))
                }
            })
    }

    sendPdf(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                if (isGoPathNewExist) {
                    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                    return this.claimReportApi.reportSendEmailPdf(data)
                } else {
                    let obj_data = {
                        'allEmp': data.allEmp,
                        'listEmp': data.listEmp,
                        'startDate': data.startDate,
                        'endDate': data.endDate,
                        'reportType': data.reportType,
                        'claimType': data.claimType,
                        'companyId': data.companyId,
                        'companyCode': data.companyCode,
                        'fullName': data.fullName,
                        'emailUser': data.email,
                        'sendEmail': true,
                        'isSF6': data.isSF6
                    };
                    return this.sFClaimReportApi.pdfmake(JSON.stringify(obj_data))
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/claim-report.bloc.ts